import { useQuery } from 'react-query';

import { PLACEMENT_QUERY_KEY } from '~/api/query-keys';

export type {
  PlacementBanner,
  PlacementNavigationBar,
  PlacementSearchKeyword,
  PlacementSearchTopBanner,
} from '~/api/model';

// 지면/배너는 상품 목록보다 변동이 있을 수 있으나, 프리페치 후 mount 즉시
// background refetch 되는 것을 막기 위해 짧은 staleTime(1분)을 부여한다.
const PLACEMENT_STALE_TIME = 60 * 1000;

// datadog businessId NaN 에러 방지 (초기값 '-1' 도 enabled 로 둔다 — MKPC-2053)
const isValidBusinessId = (businessId: string) =>
  !Number.isNaN(Number(businessId));

/** GNB 네비게이션 바 조회 */
// GET /api/market-place/v1/placements/navigation-bars-new
export const useNavigationBars = (businessId: number) => {
  const { queryKey, queryFn } = PLACEMENT_QUERY_KEY.navigationBars(businessId);

  return useQuery(queryKey, queryFn, {
    suspense: true,
    staleTime: PLACEMENT_STALE_TIME,
  });
};

/** 지면 배너 조회 */
// GET /api/market-place/v1/placements/banners
export const usePlacementBanners = (businessId: string, placement: string) => {
  const { queryKey, queryFn } = PLACEMENT_QUERY_KEY.banners(
    Number(businessId),
    placement,
  );

  return useQuery(queryKey, queryFn, {
    enabled: isValidBusinessId(businessId),
    keepPreviousData: true,
    suspense: false,
    staleTime: PLACEMENT_STALE_TIME,
  });
};

/** 검색 추천 키워드(광고) 조회 */
// GET /api/market-place/v1/placements/search-keywords
export const usePlacementSearchKeywords = (
  businessId: string,
  placement: string,
) => {
  const { queryKey, queryFn } = PLACEMENT_QUERY_KEY.searchKeywords(
    Number(businessId),
    placement,
  );

  return useQuery(queryKey, queryFn, {
    enabled: isValidBusinessId(businessId),
    keepPreviousData: true,
    suspense: false,
    staleTime: PLACEMENT_STALE_TIME,
  });
};

/** 검색 상단 배너 조회 */
// GET /api/market-place/v1/placements/search-top-banners
export const usePlacementSearchTopBanners = (businessId: string) => {
  const { queryKey, queryFn } = PLACEMENT_QUERY_KEY.searchTopBanners(
    Number(businessId),
  );

  return useQuery(queryKey, queryFn, {
    enabled: isValidBusinessId(businessId),
    keepPreviousData: true,
    suspense: false,
    staleTime: PLACEMENT_STALE_TIME,
  });
};
